<template>
  <div class="footer">
    <div class="footerImg">
      <div class="phone">
      <div class="qrCode" style="width: 86px;font-size: 14px;text-align: center;color: white;line-height: 23px">
        <img width="70" src="../assets/images/qrCode.jpg">
        <div style="margin-left: 2px">扫一扫，专业团队为你解答</div>
      </div>
      <div class="contactInformation">
        <p>热线电话</p>
        <p>0871-63302042</p>
      </div>
        <div class="contactInformation">
          <p>电子邮箱</p>
          <p>admin@wizdom.cn</p>
        </div>
        <div class="contactInformation">
          <p>公司地址</p>
          <p>云南省昆明市西山区滇池度假区中天融域二期23栋1单元209号</p>
        </div>
      <div class="contactNow" @click="goNewPage">立即联系</div>
    </div>
      </div>
    <div class="companyCopyright">
      Copyright © 2019 云南维者科技有限公司<a href="https://beian.miit.gov.cn/" target="_blank" style="color: dodgerblue">滇ICP备14004983号-4</a> 版权所有
    </div>
  </div>
</template>

<script>
export default {
  name: "bottomIntroduction",
  data() {
    return {

    }
  },
  created() {
  },
  methods: {
    goNewPage(){
      this.$router.push('/aboutUs')
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.footer .footerImg{
  width: 100%;
  min-height: 156px;
  background: url("../assets/images/footer.webp") no-repeat;
  background-size: cover;
  background-position: center;
}
/* 2026-08-17 改流式。原为 width:1230px 定宽，小屏横向溢出，
   靠 #app{overflow:hidden} 和文档页的 overflow-x:clip 各盖住一半 ——
   页面看着没坏，其实是被裁掉了。现在自己收口，不再依赖那两条规则。 */
.phone{
  padding: 25px 20px 0;
  width: min(1230px, 100%);
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 20px 28px;
  justify-content: space-between;
  align-items: center;
}
.companyCopyright{
  width: 100%;
  background-color: #333;
  text-align: center;
  line-height: 1.8;
  padding: 14px 20px;
  font-size: 14px;
  color: white;
}
.contactInformation{
  text-align: center;
  color: white;
}
.contactInformation p:nth-of-type(2){
  margin-top: 20px;
}
.contactNow{
  padding: 15px 30px;
  color: white;
  background: #0487E3;
  border-radius: 24px;
  cursor: pointer;
  white-space: nowrap;
}

/* 小屏：四块信息改成两列排布，「立即联系」占满一行 */
@media (max-width: 768px){
  .phone{
    padding: 22px 16px;
    gap: 18px 16px;
    justify-content: flex-start;
  }
  .contactInformation{
    text-align: left;
    flex: 1 1 calc(50% - 8px);
    min-width: 0;
    font-size: 14px;
    word-break: break-word;
  }
  .contactInformation p:nth-of-type(2){ margin-top: 6px; }
  .contactNow{ flex: 1 1 100%; text-align: center; }
}

</style>
